function createRoot(id) {
  var element = document.createElement('div');
  element.id = id;
  element.classList.add('notificare');
  return element;
}

function createBackdrop(onClick) {
  var backdrop = document.createElement('div');
  backdrop.classList.add('notificare__backdrop');
  backdrop.addEventListener('click', function (e) {
    // Check if a child or sibling consumed the event.
    // The event should not be processed when clicking an inner element.
    if (e.defaultPrevented) return;
    onClick();
  });
  return backdrop;
}

function createCloseIcon() {
  return new DOMParser().parseFromString("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\"><path d=\"m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z\"/></svg>\n", 'image/svg+xml').firstChild;
}

function createPrimaryButton(params) {
  return createButton(Object.assign({
    variant: 'primary'
  }, params));
}

function createSecondaryButton(params) {
  return createButton(Object.assign({
    variant: 'secondary'
  }, params));
}

function createDestructiveButton(params) {
  return createButton(Object.assign({
    variant: 'destructive'
  }, params));
}

function createButton(_ref) {
  var variant = _ref.variant,
      text = _ref.text,
      onClick = _ref.onClick;
  var button = document.createElement('button');
  button.classList.add('notificare__button', ButtonVariantCssClassMap[variant]);
  button.innerText = text;
  button.addEventListener('click', function (e) {
    e.preventDefault();
    onClick();
  });
  return button;
}

var ButtonVariantCssClassMap = {
  primary: 'notificare__button--primary',
  secondary: 'notificare__button--secondary',
  destructive: 'notificare__button--destructive'
};

function createCloseButton(_ref2) {
  var variant = _ref2.variant,
      onClick = _ref2.onClick;
  var closeIcon = createCloseIcon();
  closeIcon.classList.add('notificare__close-button-icon');
  var button = document.createElement('button');
  button.classList.add('notificare__close-button');
  if (variant === 'solid') button.classList.add('notificare__close-button--solid');
  button.appendChild(closeIcon);
  button.addEventListener('click', function (e) {
    e.preventDefault();
    onClick();
  });
  return button;
}

function createModal(params) {
  var modal = document.createElement('div');
  modal.classList.add('notificare__modal');
  if ((params === null || params === void 0 ? void 0 : params.alignment) === 'top') modal.classList.add('notificare__modal--top');
  modal.addEventListener('click', function (e) {
    // Prevent the backdrop from receiving events when content is clicked.
    e.preventDefault();
  });
  return modal;
}

function createModalHeader(_ref3) {
  var icon = _ref3.icon,
      title = _ref3.title,
      onCloseButtonClicked = _ref3.onCloseButtonClicked;
  var headerElement = document.createElement('div');
  headerElement.classList.add('notificare__modal-header');

  if (icon) {
    var iconElement = document.createElement('img');
    iconElement.classList.add('notificare__modal-header-icon');
    iconElement.setAttribute('src', icon);
    headerElement.appendChild(iconElement);
  }

  var titleElement = document.createElement('p');
  titleElement.classList.add('notificare__modal-header-title');
  titleElement.innerHTML = title !== null && title !== void 0 ? title : '';
  headerElement.appendChild(titleElement);
  headerElement.appendChild(createCloseButton({
    onClick: onCloseButtonClicked
  }));
  return headerElement;
}

function createModalContent() {
  var content = document.createElement('div');
  content.classList.add('notificare__modal-content');
  return content;
}

function createModalFooter() {
  var footer = document.createElement('div');
  footer.classList.add('notificare__modal-footer');
  return footer;
}

export { createBackdrop, createButton, createCloseButton, createDestructiveButton, createModal, createModalContent, createModalFooter, createModalHeader, createPrimaryButton, createRoot, createSecondaryButton };